import { createSelector } from '@mui/x-internals/store';
export const selectorChartExperimentalFeaturesState = state => state.experimentalFeatures;
export const selectorPreferStrictDomainInLineCharts = createSelector(selectorChartExperimentalFeaturesState, features => Boolean(features?.preferStrictDomainInLineCharts));